import React from 'react'
import Link from 'gatsby-link'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/qui">Qui suis-je?</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/reflexologie">La réflexologie</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/bienfaits">Les bienfaits</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/prestations">Prestations</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/infos">Infos / Actus</Link></li>
                <li><a href="https://fr-fr.facebook.com/annegarnier.reflexologue/">Facebook</a></li>
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: React.PropTypes.func
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js